export default __webpack_public_path__ + "static/media/search.974efb7e.svg";